import styled from 'styled-components'

import { Nav } from '@application/Interfaces/Features/Header/Nav'
import { LanguageMenu } from '@application/Interfaces/Organisms'
import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import DrawerBase from '@mui/material/Drawer'
import { HeaderThemeModeType } from '@src/Application/Types/ComponentTypes'

export const DekstopNavbar = styled(Nav)`
    display: none;

    @media only screen and (min-width: 992px) {
        display: flex;
    }
`
export const MobileNavbar = styled(Nav)`
    display: flex;

    @media only screen and (min-width: 992px) {
        display: none;
    }
`

export const HeaderWrapper = styled.div`
    position: relative;
`

export const HeaderContainer = styled.div<{ $mode: HeaderThemeModeType }>`
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;

    ${(props) => props.$mode === 'Dark' && `background: ${props.theme.color.p600};`}
    ${(props) => props.$mode === 'Light' && `background: ${props.theme.color.white};`}
    ${(props) => props.$mode === 'Transparent' && `background: none;`}
`

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    padding: 5px 15px;

    max-width: 1170px;
    margin: 0 auto;

    @media ${(props) => props.theme.query.tablet} {
        padding: 0 30px;
    }

    @media ${(props) => props.theme.query.desktop} {
        padding: 5px 0 0;
    }
`

export const LogoWrapper = styled.div`
    padding-top: 5px;
    padding-bottom: 5px;
    width: 130px;
    flex-shrink: 0;

    svg {
        width: 100%;
        height: auto;
    }

    @media ${(props) => props.theme.query.desktop} {
        width: 200px;
        margin-right: 20px;
    }

    @media ${(props) => props.theme.query.tablet} {
        margin-right: 10px;
    }
`

export const RightSidebarWrapper = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`

export const LanguageSelectionMenu = styled(LanguageMenu)`
    margin-right: 15px;
    display: none;

    @media only screen and (min-width: 992px) {
        display: block;
    }
`

export const OpenMenu = styled(ButtonBase)`
    & button:hover,
    & button:focus {
        box-shadow: unset;
    }

    @media only screen and (min-width: 992px) {
        &.menu-toggle {
            display: none;
        }
    }
`

export const Drawer = styled(DrawerBase).attrs(() => ({ classes: { paper: 'paper' } }))`
    && {
        transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;

        .paper {
            flex-wrap: nowrap;
            right: 0;
            z-index: 1;
            overflow: hidden auto;
        }

        @media only screen and (min-width: 992px) {
            display: none;
        }
    }
`

export const MobileHeader = styled.div`
    padding: 18px 16px;
    display: flex;
    justify-content: space-between;
`
